module.exports = __webpack_public_path__ + "img/SIKH TURBAN RED.1028b15.svg";